import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { OfferServiceService } from "../../services/offerServiceService";
import { PaymentMethods } from "../../constants/Constants";
import { Spin } from "antd";

const fallbackImg = "/images/placeholder-promo.jpg";

export default function ServiceOfferDetailPage() {
  const { serviceSlug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await OfferServiceService.getOfferServiceDetail(serviceSlug);
      setData(res.Data);
    })();
  }, [serviceSlug]);

  if (!data) {
    return (
      <div className="px-4 lg:px-8 py-10 text-center text-gray-500">
        <Spin spinning={true} />
      </div>
    );
  }

  const duration = [
    data.applyDate.start &&
      `Từ ${new Date(data.applyDate.start).toLocaleDateString("vi-VN")}`,
    data.applyDate.end &&
      `Đến ${new Date(data.applyDate.end).toLocaleDateString("vi-VN")}`,
  ]
    .filter(Boolean)
    .join(" • ");

  return (
    <article className="w-full">
      {/* Hero */}
      <div className="relative w-full h-[220px] lg:h-[360px] bg-gray-100">
        <img
          src={data.images || fallbackImg}
          alt={data.title}
          className="w-full h-full object-cover"
        />
        <button
          onClick={() => navigate(-1)}
          className="absolute top-3 left-3 lg:top-6 lg:left-6 px-3 py-1.5 text-sm rounded-md bg-white/80 backdrop-blur hover:bg-white"
        >
          ← Quay lại
        </button>
      </div>

      {/* Header */}
      <div className="px-4 lg:px-8 max-w-5xl mx-auto">
        <h1 className="text-2xl lg:text-4xl font-bold mt-4 lg:mt-8">
          {data.title}
        </h1>
        {data.description && (
          <p className="text-gray-600 mt-2 lg:text-lg">{data.excerpt}</p>
        )}
        {duration && (
          <p className="text-sm text-gray-500 mt-2">
            Thời gian áp dụng: {duration}
          </p>
        )}

        {/* CTA */}
        <div className="mt-4 lg:mt-6 flex flex-wrap gap-3 items-center">
          {
            <a
              href={"/products"}
              className="px-4 py-2 rounded-md bg-black text-white hover:bg-gray-800"
            >
              Xem sản phẩm
            </a>
          }
          <a
            href="https://m.me/lylyiphone"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-primaryColor text-white rounded-md hover:bg-gray-800 hover:scale-110 text-nowrap white-space-nowrap items-end"
          >
            Hỏi tư vấn
          </a>
        </div>
      </div>

      {/* Nội dung chi tiết */}
      <div className="px-4 lg:px-8 py-6 lg:py-10 max-w-5xl mx-auto space-y-8">
        {/* Mô tả / Nội dung chính */}
        {data.description && (
          <section>
            <h2 className="text-xl lg:text-2xl font-semibold">
              Mô tả chương trình
            </h2>
            <p className="text-gray-700 mt-2">{data.description}</p>
          </section>
        )}

        {/* Thông tin áp dụng */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="p-4 rounded-xl border bg-white">
            <h3 className="font-semibold mb-2">Đối tượng áp dụng</h3>
            <p className="text-gray-700">
              {data.targetAudience || "Tất cả khách hàng"}
            </p>
          </div>
          <div className="p-4 rounded-xl border bg-white">
            <h3 className="font-semibold mb-2">Hình thức thanh toán</h3>
            <p className="text-gray-700">
              {Array.isArray(data.paymentMethods) && data.paymentMethods.length
                ? PaymentMethods.filter((pm) =>
                    data.paymentMethods.includes(pm.id)
                  )
                    .map((pm) => pm.label)
                    .join(", ")
                : "Tiền mặt, Chuyển khoản, Thẻ, Trả góp"}
            </p>
          </div>
        </section>

        {/* Cách nhận ưu đãi (steps) */}
        {Array.isArray(data.instructions) && data.instructions.length > 0 && (
          <section>
            <h2 className="text-xl lg:text-2xl font-semibold">
              Cách nhận ưu đãi
            </h2>
            <ol className="list-decimal ml-5 mt-2 space-y-1 text-gray-700">
              {data.instructions.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ol>
          </section>
        )}

        {/* Điều khoản / Điều lệ */}
        {data.conditions !== "" && (
          <section>
            <h2 className="text-xl lg:text-2xl font-semibold">
              Điều khoản & Điều lệ
            </h2>
            <ul className="list-discmt-2 space-y-1 text-gray-700">
              <div className="mt-2">
                {data.conditions.split("\n").map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </div>
            </ul>
          </section>
        )}

        {/* Lưu ý */}
        {data.note !== "" && (
          <section>
            <h2 className="text-xl lg:text-2xl font-semibold">Lưu ý</h2>
            <ul className="list-disc mt-2 space-y-1 text-gray-700">
              {data.note}
            </ul>
          </section>
        )}
      </div>
      {/* Xem thêm các dịch vụ & ưu đãi khác */}
      <div className="px-4 lg:px-8 py-6 lg:py-10 max-w-5xl mx-auto space-y-8">
        <a
          href="/services-offers"
          className="text-primaryColor hover:underline"
        >
          Xem thêm các dịch vụ & ưu đãi khác
        </a>
      </div>
    </article>
  );
}
